//用户信息

<template>
<div class="">
	<header-vue></header-vue>
  <div class="container-l">
  	<div class="clearfloat width100">
  		<div id="chart2" class="chart1 clearfloat"></div>
  		<div id="chart1" class="chart1 clearfloat"></div>
  		
  		<div id="chart3" class="chart1 clearfloat"></div>
  		<div id="chart4" class="chart1 clearfloat"></div>
  	</div>
  	<div>
  		<div class="clearfloat chartbox relative-box">
  			<div id="alarmScroll" class="chart2">
  				<div class="scrollTop clear">
  					<div class="scrollBox">
  						<span class="fa fa-bell"></span>
  						<span class="num1" v-text="monthAlarmNum"></span>
  						<p>近30天告警总数</p>
  					</div>
  					<div class="scrollBox">
  						<span class="fa fa-warning"></span>
  						<span class="num1" v-text="todayAlarmNum"></span>
  						<p>当天告警总数</p>
  					</div>
  				</div>
  				<div class="scollBottom">
  					<div class="">
						<div v-for="(item,index) in alarmList" :key="index" class="gjym-boxs relative-box">
							<h4></h4>
							<p>{{index+1}}、{{item.name}}：{{item.msg}}</p>
							<p class="p6" v-text="dateFormat2(item.time)"></p>
						</div>
					</div>
					<a class="forMore" href="#/alarmStatistical">查看更多>></a>
  				</div>
  				
  			</div>
  		</div>
  		<div class="clearfloat charbox2">
  			<div id="chart7" class="chart3"></div>
  			<div id="chart8" class="chart4"></div>
  		</div>
  	</div>
    
  </div>


</div>
</template>
<script>
	import echarts from "echarts/lib/echarts"
	import 'echarts/map/js/china.js';
	export default {
		mounted() {
			this.$nextTick(function(){
//				处理时间格式
				let date = this.enddate;
				date = [
				  [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-')
				].join(' ').replace(/(?=\b\d\b)/g, '0');
				this.enddate = date;

				
				this.getChartData();
				this.getAlarmList();
		  	})
    	},
		components:{
		},
		data() {
		  	return {
		  		terminalDevice:[],
		  		collectDevice:[],
		  		terminalDeviceStatus:[],
		  		alarmDeviceType:[],
		  		alarmDeviceType2:{},
		  		userStastics:{},
		  		company_id:-1,
		  		startdate:"2018-01-01",
		  		enddate:new Date(),
		  		alarmList:[],
		  		monthAlarmNum:0,
		  		todayAlarmNum:0
		  	}
		},
		methods:{
			getChartData(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
			  		
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/DataCount/DataCount",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        			this.collectDevice = res.data.data.collectDevice || [];
		        			this.terminalDeviceStatus = res.data.data.terminalDeviceStatus || [];
		        			this.terminalDevice = res.data.data.terminalDevice || [];
		        			this.alarmDeviceType = res.data.data.alarmDeviceType || [];
		        			this.alarmDeviceType2 = res.data.data.alarmDeviceType2 || {};
		        			this.userStastics = res.data.data.userStastics || {};
		        			this.drawLine();
		        		
		        		
		        	}else if(res.data.code==10008){
					      this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
//			计算当月告警数量总和
			sum(arr) {
			    var s = 0;
			    for (var i=arr.length-1; i>=arr.length-30; i--) {
			        s += arr[i];
			    }
			    return s;
			},
//			获取告警列表
			getAlarmList(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					company_id:this.company_id,
					packet_id:-1,
					alarm_type:-1,
					alarm_device_type:-1,
					startdate:this.startdate,
					enddate:this.enddate,
					page:1,
					pagesize:5,
					token:this.getCookie('token'),
					time:Date.parse( new Date()),
					terminalId:4
		  		};
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/AlarmCount/AlarmCount",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code==200 & res.data.data!=null){
		        		
		        		this.alarmList = res.data.data.datalist || [];
		        		this.monthAlarmNum = this.sum(res.data.data.statisticsResult.data);
		        		this.todayAlarmNum = res.data.data.statisticsResult.data.pop() || 0;
		        			
		        		
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});
			},
			
			drawLine(){
				// 采集设备图表
		        let chart1 = this.$echarts.init(document.getElementById('chart1'));
		        // 绘制图表
		        chart1.setOption({
		          baseOption:{
		            title : {
		              text: '采集设备统计',
		              left:'center',
        			  top:'45%',
		              textStyle:{
						color:'#eee',
						fontWeight:'normal',
						fontSize:'16'
		              }
		            },
		            tooltip : {
		              trigger: 'item',
		              formatter: "{a} <br/>{b} : {c} ({d}%)"
		            },
		            legend: {
				        orient : 'vertical',
				        x : 'left',
						y : "2%",
						textStyle:{
							color: "#eee",
							fontSize: "12"
						},
				        data:['正常','异常','离线']
				    },
		            grid: {
		              top:'10%'
		            },
		            series : [
		              {
		                name: '采集设备统计',
		                type: 'pie',
		                radius: ['60%', '75%'],
//		              	  替换后台返回数据
		                data:this.collectDevice,
		                label: {
				                normal: {
				                    show: false,
				                    position: 'center'
				                },
				              
				            },
		                itemStyle: {
		                  emphasis: {
		                    shadowBlur: 10,
		                    shadowOffsetX: 0,
		                    shadowColor: 'rgba(0, 0, 0, 0.5)'
		                  },
		                  normal:{
		                    //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
		                    //var colorList = ['#31b0d5','#c9302c','#5cb85c','#aaa'];
		                    color: function (params){
		                      var colorList = ['#61a0a8','#c35652','#aaa','#91c7ae'];
		                      return colorList[params.dataIndex];
		                    }
		                  }
		                }
		              }
		            ]
		          }
		
		        });
				
				// 终端设备图表
		        let chart2 = this.$echarts.init(document.getElementById('chart2'));
		        // 绘制图表
		        chart2.setOption({
		          baseOption:{
		          	title : {
		              text: '终端运行情况',
		              left:'center',
        			  top:'45%',
		              textStyle:{
						color:'#eee',
						fontWeight:'normal',
						fontSize:'16'
		              }
		            },
		          	tooltip: {
				        trigger: 'item',
				        formatter: "{a} <br/>{b}: {c} ({d}%)"
				    },
				    grid: {
		              top:'10%'
		            },
				    legend: {
				        orient : 'vertical',
				        x : 'left',
						y : "2%",
						textStyle:{
							color: "#eee",
							fontSize: "12"
						},
				        data:['正常','未激活','已过期']
				    },
				    series: [
				        {
				            name:'终端运行情况',
				            type:'pie',
				            radius: ['60%', '75%'],
				            avoidLabelOverlap: false,
				            label: {
				                normal: {
				                    show: false,
				                    position: 'center'
				                }
				            },
				            labelLine: {
				                normal: {
				                    show: false
				                }
				            },
				            data:this.terminalDeviceStatus,
				            itemStyle: {
			                  normal:{
			                    //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
			                    //var colorList = ['#31b0d5','#c9302c','#5cb85c','#aaa'];
			                    color: function (params){
			                      var colorList = ['#61a0a8','#d48265','#2f4554','#91c7ae'];
			                      return colorList[params.dataIndex];
			                    }
			                  }
			                }
				        }
				    ]
		          	
		          	
		          },
		         
		
		        });
				
				// 终端数量统计
		        let chart3 = this.$echarts.init(document.getElementById('chart3'));
		    	chart3.setOption({
		          baseOption:{
		            title : {
		              text: '终端数量统计',
		              left:'center',
        			  top:'45%',
		              textStyle:{
						color:'#eee',
						fontWeight:'normal',
						fontSize:'16'
		              }
		            },
		            tooltip : {
		              trigger: 'item',
		              formatter: "{a} <br/>{b} : {c} ({d}%)"
		            },
		            grid: {
		              top:'10%'
		            },
		            legend: {
				        orient : 'vertical',
				        x : 'left',
						y : "2%",
						textStyle:{
							color: "#eee",
							fontSize: "12"
						},
				        data:['UPS', '空调','电量仪',"PDU",'LED灯','温湿度','烟雾','漏水','其他']
				    },
		            series : [
		              {
		                name: '终端数量统计',
		                type: 'pie',
		                radius: ['60%', '75%'],
//		              	  替换后台返回数据
		                data:this.terminalDevice,
		                label: {
				                normal: {
				                    show: false,
				                    position: 'center'
				                }
				            },
		                itemStyle: {
		                  emphasis: {
		                    shadowBlur: 10,
		                    shadowOffsetX: 0,
		                    shadowColor: 'rgba(0, 0, 0, 0.5)'
		                  },
		                  normal:{
		                    //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
		                    //var colorList = ['#31b0d5','#c9302c','#5cb85c','#aaa'];
		                    color: function (params){
		                      var colorList = ['#61a0a8','#c35652','#91c7ae','#d48265','#2f4554','#91c7ae','#bda29a','#91c7ae','#bda29a','#aaa'];
		                      return colorList[params.dataIndex];
		                    }
		                  }
		                }
		              }
		            ]
		          }
		
		        });
		        
		        // 告警设备统计
		        let chart4 = this.$echarts.init(document.getElementById('chart4'));
		        // 绘制图表
		        chart4.setOption({
		          baseOption:{
		          	title : {
		              text: '告警设备统计',
		              left:'center',
        			  top:'45%',
		              textStyle:{
						color:'#eee',
						fontWeight:'normal',
						fontSize:'16'
		              }
		            },
		          	tooltip: {
				        trigger: 'item',
				        formatter: "{a} <br/>{b}: {c} ({d}%)"
				    },
				    grid: {
		              top:'10%'
		            },
				    legend: {
				        orient : 'vertical',
				        x : 'left',
						y : "2%",
						textStyle:{
							color: "#eee",
							fontSize: "12"
						},
				        data:['UPS', '空调','电量仪',"PDU",'LED灯','温湿度','烟雾','漏水','其他']
				    },
				    series: [
				        {
				            name:'当月告警设备统计',
				            type:'pie',
				            radius: ['60%', '75%'],
				            avoidLabelOverlap: false,
				            label: {
				                normal: {
				                    show: false,
				                    position: 'center'
				                }
				            },
				            labelLine: {
				                normal: {
				                    show: false
				                }
				            },
				            data:this.alarmDeviceType,
				            itemStyle: {
			                  normal:{
			                    //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
			                    //var colorList = ['#31b0d5','#c9302c','#5cb85c','#aaa'];
			                    color: function (params){
			                      var colorList = ['#61a0a8','#aaa','#c35652','#91c7ae','#d48265','#bda29a','#91c7ae','#2f4554','#bda29a','#61a0a8','#91c7ae','#aaa','#c35652'];
			                      return colorList[params.dataIndex];
			                    }
			                  }
			                }
				        }
				    ]
		          	
		          	
		          },
		         
		
		        });
		    	
		    	
				let chart7 = this.$echarts.init(document.getElementById('chart7'));
		        // 绘制图表
		        chart7.setOption({
				    title: {
				    	x:'2%',
						y:"3%",
						textStyle:{
							color:'#eee',
							fontWeight:'normal',
							fontSize:'16'
						},
				        text: '近期告警设备统计'
				    },
				    tooltip : {
				        trigger: 'axis',
				        axisPointer: {
				            type: 'cross',
				            label: {
				                backgroundColor: '#6a7985'
				            }
				        }
				    },
				    legend: {
						y : "5%",
						textStyle:{
							color: "#eee",
							fontSize: "12"
						},
				        data:['UPS', '空调','电量仪',"PDU",'LED灯','温湿度','烟雾','漏水','其他']
				    },
				    grid: {
				        left: '3%',
				        right: '4%',
				        bottom: '3%',
				        top:"22%",
				        containLabel: true
				    },
				    xAxis : [
				        {
				            type : 'category',
							boundaryGap : false,
							axisLine: {
								lineStyle: {
									color: '#999'
								}
							},
				            data : this.alarmDeviceType2.yAxis
				        }
				    ],
				    yAxis : [
				        {
							type : 'value',
							axisLine: {
								lineStyle: {
									color: '#999'
								}
							},
				            splitLine: {
					            show: false
					        }
				        }
				    ],
				    series : [
				        {
				            name:'UPS',
				            type:'line',
				            stack: '总量',
				            itemStyle: {
				                normal: {
				                    color: '#8ec6ad'
				                }
				            },
				            areaStyle: {
				                normal: {
				                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
				                        offset: 0,
				                        color: '#8ec6ad'
				                    }, {
				                        offset: 1,
				                        color: '#ffe'
				                    }])
				                }
				            },
				            smooth: true,
				            data:this.alarmDeviceType2.UPSSeries
				            
				        },
				        {
				            name:'空调',
				            type:'line',
				            stack: '总量',
				            areaStyle: {
				                normal: {
				                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
				                        offset: 0,
				                        color: '#d68262'
				                    }, {
				                        offset: 1,
				                        color: '#ffe'
				                    }])
				                }
				            },
				            itemStyle: {
				                normal: {
				                    color: '#d68262'
				                }
				            },
				            smooth: true,
				            data:this.alarmDeviceType2.airSeries
				        },
				        {
				            name:'PDU',
				            type:'line',
				            stack: '总量',
				            areaStyle: {
				                normal: {
				                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
				                        offset: 0,
				                        color: '#c35652'
				                    }, {
				                        offset: 1,
				                        color: '#ffe'
				                    }])
				                }
				            },
				            itemStyle: {
				                normal: {
				                    color: '#c35652'
				                }
				            },
				            smooth: true,
				            data:this.alarmDeviceType2.PDUSeries
				        },
				        {
				            name:'LED灯',
				            type:'line',
				            stack: '总量',
				            areaStyle: {
				                normal: {
				                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
				                        offset: 0,
				                        color: '#91c7ae'
				                    }, {
				                        offset: 1,
				                        color: '#ffe'
				                    }])
				                }
				            },
				            itemStyle: {
				                normal: {
				                    color: '#91c7ae'
				                }
				            },
				            smooth: true,
				            data:this.alarmDeviceType2.LEDSeries
				        },
				        {
				            name:'温湿度',
				            type:'line',
				            stack: '总量',
				            areaStyle: {
				                normal: {
				                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
				                        offset: 0,
				                        color: '#d48265'
				                    }, {
				                        offset: 1,
				                        color: '#ffe'
				                    }])
				                }
				            },
				            itemStyle: {
				                normal: {
				                    color: '#d48265'
				                }
				            },
				            smooth: true,
				            data:this.alarmDeviceType2.humitureSeries
				        },
				        {
				            name:'烟感',
				            type:'line',
				            stack: '总量',
				            areaStyle: {
				                normal: {
				                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
				                        offset: 0,
				                        color: '#2f4554'
				                    }, {
				                        offset: 1,
				                        color: '#ffe'
				                    }])
				                }
				            },
				            itemStyle: {
				                normal: {
				                    color: '#2f4554'
				                }
				            },
				            smooth: true,
				            data:this.alarmDeviceType2.smokeSeries
				        },
				        {
				            name:'漏水',
				            type:'line',
				            stack: '总量',
				            areaStyle: {
				                normal: {
				                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
				                        offset: 0,
				                        color: '#91c7ae'
				                    }, {
				                        offset: 1,
				                        color: '#ffe'
				                    }])
				                }
				            },
				            itemStyle: {
				                normal: {
				                    color: '#91c7ae'
				                }
				            },
				            smooth: true,
				            data:this.alarmDeviceType2.leakwaterSeries
				        },
				        {
				            name:'其他',
				            type:'line',
				            stack: '总量',
				            areaStyle: {
				                normal: {
				                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
				                        offset: 0,
				                        color: '#bda29a'
				                    }, {
				                        offset: 1,
				                        color: '#ffe'
				                    }])
				                }
				            },
				            itemStyle: {
				                normal: {
				                    color: '#bda29a'
				                }
				            },
				            smooth: true,
				            data:this.alarmDeviceType2.otherSeries
				        }
				    ]
				});
		    	
		        let chart8 = this.$echarts.init(document.getElementById('chart8'));
		        // 绘制图表
		        chart8.setOption({
				    title: {
				    	x:'2%',
						y:"3%",
						textStyle:{
							color:'#eee',
							fontWeight:'normal',
							fontSize:'16'
						},
				        text: '用户统计'
				    },
				    tooltip : {
				        trigger: 'axis',
				        axisPointer: {
				            type: 'cross',
				            label: {
				                backgroundColor: '#6a7985'
				            }
				        }
				    },
				    legend: {
						y : "5%",
						textStyle:{
							color: "#eee",
							fontSize: "12"
						},
				        data:['注册用户','活动用户']
				    },
				    grid: {
				        left: '3%',
				        right: '4%',
				        bottom: '3%',
				        top:"22%",
				        containLabel: true
				    },
				    xAxis : [
				        {
				            type : 'category',
							boundaryGap : false,
							axisLine: {
								lineStyle: {
									color: '#999'
								}
							},
				            data : this.userStastics.xAxis
				        }
				    ],
				    yAxis : [
				        {
							type : 'value',
							axisLine: {
								lineStyle: {
									color: '#999'
								}
							},
				            splitLine: {
					            show: false
					        }
				        }
				    ],
				    series : [
				    	{
				            name:'活动用户',
				            type:'line',
				            stack: '总量',
				            areaStyle: {
				                normal: {
				                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
				                        offset: 0,
				                        color: '#8ec6ad'
				                    }, {
				                        offset: 1,
				                        color: '#ffe'
				                    }])
				                }
				            },
				            itemStyle: {
				                normal: {
				                    color: '#8ec6ad'
				                }
				            },
				            smooth: true,
				            data:this.userStastics.activeUserSeries
				        },
				        {
				            name:'注册用户',
				            type:'line',
				            stack: '总量',
				            itemStyle: {
				                normal: {
				                    color: '#d68262'
				                }
				            },
				            areaStyle: {
				                normal: {
				                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
				                        offset: 0,
				                        color: '#d68262'
				                    }, {
				                        offset: 1,
				                        color: '#ffe'
				                    }])
				                }
				            },
				            smooth: true,
				            data:this.userStastics.regUserSeries
				            
				        }
				        
				    ]
				});
			}
		
		}
	}

</script>


<style scoped>
	
</style>



// WEBPACK FOOTER //
// src/components/plate.vue